import { render, staticRenderFns } from "./diagnosisCouponDetail.vue?vue&type=template&id=d98ba5ba&scoped=true"
import script from "./diagnosisCouponDetail.vue?vue&type=script&lang=js"
export * from "./diagnosisCouponDetail.vue?vue&type=script&lang=js"
import style0 from "./diagnosisCouponDetail.vue?vue&type=style&index=0&id=d98ba5ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d98ba5ba",
  null
  
)

export default component.exports